module.exports = __webpack_public_path__ + "img/slack.8959cb59.png";